export default __webpack_public_path__ + "static/media/fileEdit.202bad46.svg";